// https://www.figma.com/design/N6qGPH8kxtOSHDx6wXKFoZ/Aphrodite?node-id=1811-2020&t=29PqII1xLV5c1GXu-0
export type WaveProps = {
  color: string;
  strokeWidth?: number;
};

export function Wave1(props: WaveProps) {
  return (
    <svg viewBox="0 0 365 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.8252 40.4094C57.1552 87.4094 111.925 92.5494 194.825 46.5294C266.425 6.77945 310.825 7.27945 355.175 51.7494"
        stroke={props.color}
        strokeWidth={26 * (props.strokeWidth || 1)}
      />
    </svg>
  );
}

export function Wave5(props: WaveProps) {
  return (
    <svg viewBox="0 0 343 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 85.73C42.41 55.59 84.63 29.79 135.46 38.1C190.71 47.1 220.16 80.03 282.25 58.22C306.36 49.75 327.16 20.48 330.59 11"
        stroke={props.color}
        strokeWidth={26 * (props.strokeWidth || 1)}
      />
    </svg>
  );
}
